<template>
  <div>
    <div class="form-group-style">
      <el-form
        class="form-container"
        :model="info"
        ref="ModelForm"
        :rules="modelRules"
      >
        <div class="form-item bidding-tips">
          <div class="form-label">
            <span class="label">操作说明：</span>
          </div>
          <div class="form-input-item">
            <el-form-item>
              <p>
               1.动态取值字段请用<span class="red">[标签名]</span>表示，如<span class="red">[城市]</span> 在长沙站生成导购文章内展示为：长沙，广州站生成导购文章内展示为：广州。
              </p>
              <p>
               2.支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span> 进行查看。
              </p>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">模板分类：</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="type_id">
              <el-select v-model="info.type_id" placeholder="请选择">
                  <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
       <div class="form-item">
          <div class="form-label">
            <span class="label">模板名称：</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="name">
              <el-input
                placeholder="请输入动态模板名称"
                class="input-control"
                v-model="info.name"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">动态标题</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="title">
                <el-input
                  placeholder="请输入模板名称"
                  class="input-control"
                  v-model="info.title"
                ></el-input>
            </el-form-item>
          </div>
        </div>
         <div class="form-item">
          <div class="form-label">
            <span class="label">动态内容</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item editor" style="width:1000px">
              <el-form-item prop="content">
                <UE :options="eidtorOptions" defaultMsg="" ref="ue" />
              </el-form-item>
            </div>
        </div>

        <div class="form-button">
            <el-button type="primary" :loading="isloading"  @click="submitForm('ModelForm',1)"
                >保存</el-button
            >
            <el-button type="info" plain @click="toList()">取 消</el-button>
        </div>
      </el-form>
    </div>
    <tag-lib ref="tagLib"></tag-lib>

  </div>
</template>
<script>
import { validateEmpty } from "@/utils/validate";
import { NEWS_MODEL } from "@/config/index";
import { UPLOAD_CODE } from "@/config/index";
import EditorBar from "@/components/newsModelEditor/modelEditor";
import UE from '@/components/editoritem/uEditor';
import {dynamicModelAdd,dynamicModelEdit,getDynamicModelDetail} from '@/service/dynamicModel'
import TagLib from './component/tagLib';


export default {
  name: "add",
  components: {
    EditorBar,
    UE,
    TagLib
  },
  data() {
    return {
      isloading:false,
      info: {
        type_id: 1,
        name:"",
        title: "",
        content: "",
      },
      houseCardId:'',
      modelId:'',
      typeList:[{
        id:1,
        name:"楼盘动态"
      },{
        id:2,
        name:"开盘信息"
      },{
        id:3,
        name:"交房信息"
      },{
        id:4,
        name:"证件信息"
      }],
      inputVisible: false,
      inputValue: "",
      isClear: false,
      modelRules: {
        // type_id:[
        //   { required: true, message:"请选择模板分类",result: "模板分类", trigger: "blur" }
        // ],
        name: [
          { validator: validateEmpty, result: "模板名称", trigger: "blur" },
          { min: 1, max:32, message: "长度1到32个字符" },
        ],
        title: [
          { validator: validateEmpty, result: "动态标题", trigger: "blur" },
          { min: 1, max:32, message: "长度1到32个字符" },
        ],
        content: [
          { validator: validateEmpty, result: "动态内容", trigger: "blur" },
          { min: 1, max: 15000, message: "长度1到15000个字符" }
        ]
      },
      // 编辑器配置
      eidtorOptions: {
        pictureConfig: {
          code: UPLOAD_CODE.news
        },
        videoConfig: {
          code: UPLOAD_CODE.newsVideo
        },
        wordLimit:3000,
        uploadType:'common',
        config: {
          items : ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen','addIframe'],
        }
      },
    };
  },
  mounted(){
    const id = this.$route.query.id;
    if (id) {
        this.modelId = id
        this.getModelDetail(id,'edit')
    }
  },
  methods: {
    showTagLib(){
        this.$refs.tagLib.openMenu()
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    async getModelDetail(id,type){
      await getDynamicModelDetail(id).then((data) => {
        this.info = data;
        if(type && type != 'add'){
          this.$refs.ue.pushContent(data.content);         
        }
        this.houseCardId = data.rcid;
      })
    },
    resetForm() {
      this.$refs.modelRules && this.$refs.modelRules.clearValidate();
    },
    toList() {
      this.$router.push("modelList");
    },
    submitForm(formName,type) {
      this.info.content = this.$refs.ue.getContent().html;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.isloading = true
          let query = this.info;
          if(this.modelId){
            this.edit(this.modelId,query);
          }else{
            this.add(query);
          }
        } else {
          return false;
        }
      });
    },
    add(query,type){
      dynamicModelAdd(query)
        .then((data) => {
          this.$message({
            message: "添加成功",
            type: "success",
            duration: 3 * 1000,
          });
          this.isloading = false
          this.toList();
        })
        .catch((err) => {
          this.$message({
            message: err.message || "添加失败",
            type: "error",
            duration: 3 * 1000,
          });
          this.isloading = false
          
        });
    },
    edit(id,query,type){
      dynamicModelEdit(id,query)
        .then((data) => {
          this.$message({
            message: "编辑成功",
            type: "success",
            duration: 3 * 1000,
          });
          this.isloading = false
          this.toList();       
        })
        .catch((err) => {
          this.$message({
            message: err.message || "编辑失败",
            type: "error",
            duration: 3 * 1000,
          });
          this.isloading = false
        });
    }
  },
};
</script>
<style scoped lang="less">

.form-group-style .form-input-item .el-tag /deep/ .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;
}
.form-group-style .form-container .form-item .form-label {
  width: 20%;
}
.form-group-style .form-container .form-input-item {
  width: 40%;
}
.form-group-style {
  min-height: 600px;
  background-color: #fff;
}
.bidding-tips .form-input-item {
  width: 50% !important;
}
.huxing-input {
  display: -webkit-box;
  height: 152px;
  .el-form-item {
    -webkit-box-flex: 1;
  }
  .labels {
    font-size: 13px;
    color: #666;
    padding: 0 8px;
    display: block;
  }
  .flex-all {
    -webkit-box-flex: 1;
  }
}
.checked-labels {
  border: 1px solid #e4e7ed;
  font-size: 13px;
  color: #666;
  padding: 0px 16px;
  border-radius: 3px;
  margin: 0 15px 15px 0;
  display: inline-block;
  position: relative;
  cursor: pointer;
  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    transition: all 0.1s linear;
    opacity: 0;
    .el-icon-delete {
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 15px;
      height: 20px;
      display: block;
    }
  }
  &:hover {
    .shadow {
      opacity: 1;
    }
  }
}
p.tip {
  color: #666;
  margin-left: 20px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: auto;
  margin-left: 10px;
  vertical-align: bottom;
}
.red{
    color:red;
}
.add-btn{
  margin-left:10px;
}
</style>